var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTransferinline = function SvgTransferinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    x: 0.5,
    y: 0.5,
    stroke: "currentColor",
    rx: 3.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.8 14V6.8h1.045v6.215h3.26V14zm6.409 0V7.95l-1.355.825V7.61l1.355-.81h1.065V14z"
  })));
};
export default SvgTransferinline;